import { apiClients } from '../apiClients';
import { ApiClient } from '../lib/ApiClient';
import { LiveStatusCheckError } from '../types/errors/LiveStatusCheckError';

import { GetStreamsDto } from './types/GetStreamsDto';

export class TwitchHelixService {
	private static get twitchHelixApi(): ApiClient {
		if (!apiClients.twitchHelixApi) {
			throw new Error('Twitch Helix API client not initialized');
		}

		return apiClients.twitchHelixApi;
	}

	public static async isStreamerLive(channelId: string): Promise<boolean> {
		try {
			const response =
				await TwitchHelixService.twitchHelixApi.request<GetStreamsDto>({
					path: `/streams?user_id=${channelId}&type=live`,
					headers: {
						'content-type': 'application/json',
					},
				});

			return response.ok && response.data.data.length > 0;
		} catch (error) {
			LiveStatusCheckError.report({ cause: error });
		}

		return false;
	}
}
